export function faqAccordion() {
    const $accordion = $(".questions-accordion");
    const $buttons = $accordion.find(".open-btn");


    $buttons.click(function() {
        const $parent = $(this).parents(".item");
        const $answer = $parent.find(".answer");

        $answer.slideToggle(300);
        $parent.toggleClass("expanded");
    });
}


// WEBPACK FOOTER //
// ./assets/js/modules/faq-accordion.js